(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[2736],{

/***/ 38353:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $6: () => (/* binding */ NonUniqueConstraintError),
/* harmony export */   AQ: () => (/* binding */ InternalError),
/* harmony export */   Ep: () => (/* binding */ InvalidPublicApiTrigger),
/* harmony export */   JG: () => (/* binding */ MissingRequiredActionError),
/* harmony export */   L0: () => (/* binding */ InvalidJSONDefaultError),
/* harmony export */   LN: () => (/* binding */ DefaultIgnoredJSDiagnosticCodes),
/* harmony export */   OZ: () => (/* binding */ MissingRequiredFieldError),
/* harmony export */   X4: () => (/* binding */ MissingRequiredValidationError),
/* harmony export */   _K: () => (/* binding */ UnknownInputTypeError),
/* harmony export */   fE: () => (/* binding */ UserInitiatedActionSemanticError),
/* harmony export */   m2: () => (/* binding */ BrokenPackageJSONError),
/* harmony export */   uY: () => (/* binding */ MisconfiguredActionError)
/* harmony export */ });
/* unused harmony exports GadgetError, errorClass, ErrorGroup, GraphQLTransactionSequenceError, ClientTransactionTimeoutError, DatabaseOperationTimeoutError, NotFoundError, PermissionDeniedError, UnknownFieldError, InvalidIDError, InvalidBackgroundActionIDError, InvalidQueryInputError, InvalidActionInputError, InvalidStoredDataError, InvalidAPIKeyError, InvalidInternalAuthTokenError, InvalidAuthModeError, MisconfiguredFieldError, UniqueValidationNotSupportedError, InactiveSessionAccessError, UserNotSetOnSessionError, NoSessionForAuthenticationError, IncorrectEnvironmentTokenError, IncorrectAppTokenError, ExpiredSessionForAuthenticationError, AuthorizationCodeValidationError, AuthorizationInvalidRequest, UnknownPlanItemError, ShopifyInvalidPlanNameError, NoTransitionError, MissingRequiredModelError, MissingRequiredDataError, PreconditionsFailedForActionError, ActionTimeoutError, MisconfiguredValidationError, MisconfiguredCodeSnippetError, FailedNetworkOperationError, StillSettingUpError, UndeployedEnvironmentError, TooManyRequestsError, InfiniteLoopError, InvalidPageSizeError, InvalidBackwardsPaginationError, SandboxReloadingError, AppCrashError, InvalidShopifySessionTokenError, ShopifyAuthenticationError, ShopifyForbiddenError, MissingIdentifierInRemoteBlobError, UnforkableAppError, WebhookRegistrationError, ApplicationLockedError, PaymentRequiredError, ShopifyFrozenError, ShopifyUnavailableError, ShopifyRequestError, ShopifyRateLimitError, AssetBuildFailedError, DifferentVectorDimensionsError, InvalidActionTrigger, BadRequestError, InvalidEmailError, PostgresIndexError, InvalidActionReturnType, InvalidEmailPasswordError, InvalidResetPasswordTokenError, InvalidEmailVerificationToken, InvalidCurrentPasswordError, EmailUnverifiedError, InvalidPasswordResetRequest, EmailNotFoundError, GadgetErrors */
/* harmony import */ var lodash_defaults__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73821);
/* harmony import */ var lodash_defaults__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_defaults__WEBPACK_IMPORTED_MODULE_0__);

/**
 * Parent class for all the enhanced errors in any gadget-owned package
 */ class GadgetError extends Error {
    /** Was this error caused by the Gadget application's code */ causedByUserland = false;
    /** Was this error caused by the API client calling the Gadget application */ causedByClient = false;
    /** What HTTP status code should be sent when responding with this error */ statusCode = 500;
    /** A GGT_SOMETHING human/machine readable string unique error class name */ code;
    /** If this error is thrown, should we allow its code, message, and details to be sent to the client. Defaults to true for errors with 400 series status codes and false otherwise. */ exposeToClient;
    /** If this error is thrown, should we allow its code, message, and details to be sent to the sandbox. Defaults to true. */ exposeToSandbox;
    /** Optional bag of data about this error */ details;
    /** Was this error already logged? */ logged = false;
}
/**
 * Produce a GadgetError subclass that includes the nice error handling goodies, which are:
 *  - a stable, predictable, google-able `code` for all errors, which is really nice for consumers of Gadget apps
 *  - automatic addition of the error code to the message
 *  - a `statusCode` property for Starscream's default error handler to use to reply to requests with from the error handlers
 *  - a `causedByClient` property for for error handlers to decide if the error was caused by something within the requester's control. For example, should be true for an error generated by invalid GraphQL query syntax, but false for failing to connect to Postgres.
 *  - a `causedByUserland` property for error handlers to use to identify if the error was the fault of Gadget itself, or something broken with an app being built on Gadget. Should be true for an error in a Gadget app's effect code, but false for something inside Gadget's framework
 */ const errorClass = (code, defaultMessage, options = {})=>{
    const opts = lodash_defaults__WEBPACK_IMPORTED_MODULE_0___default()(options, {
        statusCode: 500,
        causedByClient: false,
        causedByUserland: false,
        logged: false
    });
    return class extends GadgetError {
        details;
        static code = code;
        code;
        statusCode;
        causedByClient;
        causedByUserland;
        logged;
        exposeToClient;
        exposeToSandbox;
        /** JS classname of this error instance */ name;
        /** Inner error which caused this error */ cause;
        constructor(message = defaultMessage, details){
            super(`${code}: ${message}`);
            this.details = details;
            this.code = code;
            this.statusCode = opts.statusCode;
            this.causedByClient = opts.causedByClient;
            this.causedByUserland = opts.causedByUserland;
            this.logged = opts.logged;
            this.exposeToClient = opts.exposeToClient ?? (opts.causedByClient || opts.statusCode >= 400 && opts.statusCode < 500);
            this.exposeToSandbox = opts.exposeToSandbox ?? opts.causedByUserland;
            this.details = details;
            if (details?.cause) {
                this.cause = details.cause;
                delete details.cause;
            }
            this.name = this.constructor.name;
        }
    };
};
/**
 * Aggregates a number of errors that occurred when processing a unit of work
 */ class ErrorGroup extends (/* unused pure expression or super */ null && (Error)) {
    errors;
    static code = (/* unused pure expression or super */ null && ("GGT_MANY_ERRORS"));
    code;
    constructor(errors){
        super(`${errors.length} error${errors.length == 1 ? "" : "s"} occurred`);
        this.errors = errors;
        this.code = "GGT_MANY_ERRORS";
    }
    get statusCode() {
        return Math.max(...this.errors.map((e)=>e.statusCode));
    }
    get causedByClient() {
        return this.errors.some((e)=>e.statusCode);
    }
    get causedByUserland() {
        return this.errors.some((e)=>e.statusCode);
    }
}
/**
 * Catch all error thrown when something unexpected happens within the Gadget platform that isn't directly the app developer's fault.
 * Indicates that the error is the fault of the platform, and hides the details of why in case it might leak sensitive information.
 * Try not to use this as it isn't actionable by app developers, but if something really is our fault and out of their control, it's cool.
 */ class InternalError extends errorClass("GGT_INTERNAL_ERROR", "An internal error occurred.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: false
}) {
}
/** Thrown when an app tries to run start/stop transaction calls in the wrong order */ class GraphQLTransactionSequenceError extends errorClass("GGT_INCORRECT_TRANSACTION_SEQUENCE", "Can't take this operation right now", {
    statusCode: 500,
    causedByClient: true,
    causedByUserland: false,
    exposeToSandbox: true
}) {
}
/** Thrown when an app runs a transaction that takes too long that we then abort */ class ClientTransactionTimeoutError extends errorClass("GGT_TRANSACTION_TIMEOUT", "This transaction took too long before being committed, all the work within it needs to be completed within 5 seconds.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true,
    exposeToSandbox: true
}) {
}
/** Thrown when an app runs a particular database statement that takes too long, which the database then aborts */ class DatabaseOperationTimeoutError extends errorClass("GGT_DATABASE_OPERATION_TIMEOUT", "One operation in the backend database took too long to execute and was cancelled.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
    constructor(message, details){
        super(message, details);
    }
}
/** Thrown when an app tries to read or take action on a specific record by ID, but that record can't be found */ class NotFoundError extends errorClass("GGT_RECORD_NOT_FOUND", "The record couldn't be found in the database.", {
    statusCode: 404,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Thrown when an API client tries to access data that it's roles don't grant it access to. */ class PermissionDeniedError extends errorClass("GGT_PERMISSION_DENIED", "Permission denied to access this resource.", {
    statusCode: 403,
    causedByClient: true,
    causedByUserland: false
}) {
    details;
    actor;
    actorRoleKeys;
    resource;
    constructor(message, details = {}){
        super(message, details);
        this.details = details;
        this.actor = details.actor;
        this.actorRoleKeys = details.actorRoleKeys;
        this.resource = details.resource;
    }
}
/** Thrown when an API client tries to retrieve or mutate a field on a model that doesn't exist */ class UnknownFieldError extends errorClass("GGT_UNKNOWN_FIELD", "Trying to retrieve or store a field apiIdentifier that doesn't exist", {
    statusCode: 500,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Thrown when a GraphQL query makes a request with a value for an ID that doesn't look like an ID */ class InvalidIDError extends errorClass("GGT_INVALID_ID", "Couldn't convert to a Gadget ID, it must be a string containing only digits", {
    statusCode: 422,
    causedByClient: true,
    causedByUserland: true
}) {
}
/** Thrown when a GraphQL query makes a request with a value for an ID that doesn't look like an ID */ class InvalidBackgroundActionIDError extends errorClass("GGT_INVALID_BACKGROUND_ACTION_ID", "The provided data wasn't a valid background action identifier", {
    statusCode: 422,
    causedByClient: true,
    causedByUserland: true
}) {
}
/** Thrown when an API request specifies an invalid argument for some field */ class InvalidQueryInputError extends errorClass("GGT_INVALID_QUERY_INPUT", "Input was invalid for a query field", {
    statusCode: 422,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Thrown either when an API request specifies an unknown action in the input, or multiple nested actions in a single blob */ class InvalidActionInputError extends errorClass("GGT_INVALID_ACTION_INPUT", "Input was invalid for an action", {
    statusCode: 422,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Thrown when an API request retrieves a record who's stored data no longer matches the validations for that model*/ class InvalidStoredDataError extends errorClass("GGT_INVALID_STORED_DATA", "The database has stored data which is not valid for the current schema and must be corrected to be read", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Represents permission being denied when an api key is passed but it isn't valid */ class InvalidAPIKeyError extends errorClass("GGT_INVALID_API_KEY", "Invalid API key. Please ensure you're passing an API Key directly copied from the Gadget Editor, which is a string starting with `gsk-`.", {
    statusCode: 403,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** The permission denied error thrown when a request is using the internal auth mechanism but doesn't provide a valid token */ class InvalidInternalAuthTokenError extends errorClass("GGT_INVALID_INTERNAL_AUTH_TOKEN", "Invalid internal auth token.", {
    statusCode: 403,
    causedByClient: false,
    causedByUserland: false,
    exposeToSandbox: true
}) {
}
/** Thrown when trying to make a request using an auth mechanism that doesn't make sense */ class InvalidAuthModeError extends errorClass("GGT_INVALID_AUTH_MODE", "Invalid authentication mode.", {
    statusCode: 403,
    causedByClient: true
}) {
}
/** Thrown when trying to process a request for an application that has broken relationships set up among its models */ class MisconfiguredFieldError extends errorClass("GGT_MISCONFIGURED_FIELD", "A relationship type field (Has One, HasMany, Has Many Through or Belongs To) is set up incorrectly.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
    get extensions() {
        return {
            problems: this.details?.problems
        };
    }
}
/** Thrown when trying to insert/update a record that violates a uniqueness validation */ class NonUniqueConstraintError extends errorClass("GGT_NON_UNIQUE_DATA", "Data is being added or changed on a record which is non unique among the other records of the model and is thus invalid.", {
    statusCode: 422,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Thrown when the storage strategy doesn't support unique indexes */ class UniqueValidationNotSupportedError extends errorClass("GGT_UNIQUE_VALIDATION_NOT_SUPPORTED", "Unique validation is not supported by this storage strategy.", {
    statusCode: 422,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Thrown when invalid JSON schema is used in input params */ class UnknownInputTypeError extends errorClass("GGT_UNKNOWN_INPUT_TYPE", "An unknown input param type was encountered in the schema", {
    statusCode: 422,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Thrown when trying to access the `currentSession` field of a GraphQL API and the requestor doesn't have a session set up */ class InactiveSessionAccessError extends errorClass("GGT_INACTIVE_SESSION_ERROR", "Can't access or act on a session without a session active.", {
    statusCode: 422,
    causedByClient: true,
    causedByUserland: false
}) {
}
/**
 * Represents what is thrown when a user could not be set on a newly signed in session
 */ class UserNotSetOnSessionError extends errorClass("GGT_USER_NOT_SET_ON_SESSION", "User not set on session", {
    causedByClient: true,
    causedByUserland: false
}) {
}
/**
 * Represents what is thrown when there is no authenticated user in scope after logging in
 */ class NoSessionForAuthenticationError extends errorClass("GGT_NO_SESSION_FOR_AUTHENTICATION", "There is no authenticated user in scope.", {
    causedByClient: true,
    causedByUserland: false
}) {
}
/**
 * Thrown when a token was issued for a different environment within the same app
 */ class IncorrectEnvironmentTokenError extends errorClass("GGT_INCORRECT_ENVIRONMENT", "Token is not valid for this environment", {
    causedByClient: true,
    causedByUserland: false,
    statusCode: 403
}) {
}
/**
 * Thrown when a token is used for the incorrect app
 */ class IncorrectAppTokenError extends errorClass("GGT_INCORRECT_APP", "Token is not valid for this app", {
    causedByClient: true,
    causedByUserland: false,
    statusCode: 401
}) {
}
/**
 * Represents what is thrown when there is an expired session token
 */ class ExpiredSessionForAuthenticationError extends errorClass("GGT_EXPIRED_SESSION_FOR_AUTHENTICATION", "The session is not longer valid or has expired", {
    causedByClient: true,
    causedByUserland: false,
    statusCode: 401
}) {
}
/**
 * Thrown when there's an issue with the authorization code that was sent in the token exchange request
 */ class AuthorizationCodeValidationError extends errorClass("GGT_AUTH_INVALID_GRANT", "The provided authorization grant (e.g., authorization code, resource owner credentials) or refresh token is invalid, expired, revoked, does not match the redirection URI used in the authorization request, or was issued to another client.", {
    causedByClient: true,
    causedByUserland: false,
    statusCode: 400
}) {
}
/**
 * Thrown when a code verifier is not included with an authorization code
 */ class AuthorizationInvalidRequest extends errorClass("GGT_AUTH_INVALID_REQUEST", "", {
    causedByClient: true,
    causedByUserland: false,
    statusCode: 400
}) {
}
/** Thrown when a plan item references another plan item that doesn't exist (e.g., via `_linkVia`) */ class UnknownPlanItemError extends errorClass("GGT_UNKNOWN_PLAN_ITEM", "Execution plan item referenced an unknown plan item", {
    statusCode: 422,
    causedByClient: false,
    causedByUserland: false
}) {
}
/** Thrown when a plan name is in Gadget's unsupported types for shop syncs */ class ShopifyInvalidPlanNameError extends errorClass("GGT_INVALID_PLAN_NAME", "Shop with plan name of ['frozen', 'cancelled', 'fraudulent'] is invalid for syncing.", {
    statusCode: 422,
    causedByClient: false,
    causedByUserland: true,
    exposeToSandbox: true
}) {
}
/** Represents what is thrown when an action can't be taken on a record because it's an illegal state transition */ class NoTransitionError extends errorClass("GGT_NO_TRANSITION", "Invalid action", {
    statusCode: 422,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Represents what is thrown when Gadget wants to work with a model but the model can't be found */ class MissingRequiredModelError extends errorClass("GGT_MISSING_REQUIRED_MODEL", "Gadget needs a specific model to exist in the application to perform this operation, but the model does not exist.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Represents what is thrown when Gadget wants to invoke an action on a model but the action can't be found */ class MissingRequiredActionError extends errorClass("GGT_MISSING_REQUIRED_ACTION", "Gadget needs a specific action to exist on a model to perform this operation, but the action does not exist.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Represents what is thrown when Gadget wants to invoke an action on a model but the action can't be found */ class MissingRequiredFieldError extends errorClass("GGT_MISSING_REQUIRED_FIELD", "Gadget needs a specific field to exist on a model to perform this operation, but the field does not exist.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Represents what is thrown when Gadget wants to access data of a record but the data is not present */ class MissingRequiredDataError extends errorClass("GGT_MISSING_REQUIRED_DATA", "Gadget needs a specific field to be set on a record to perform this operation, but the field is null or undefined.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Represents what is thrown when Gadget wants to access data of a record but the data is not present */ class MissingRequiredValidationError extends errorClass("GGT_MISSING_REQUIRED_VALIDATION", "Gadget needs a specific validation to exist on a model to perform this operation, but the validation does not exist", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Represents what is thrown when an action can't be taken on a record because the preconditions failed */ class PreconditionsFailedForActionError extends errorClass("GGT_PRECONDITIONS_FAILED", "Invalid action", {
    statusCode: 422,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Represents what is thrown when something unexpected goes wrong and the state machine can't execute */ class ActionTimeoutError extends errorClass("GGT_ACTION_TIMEOUT", "Timed out while executing action", {
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Thrown when an action is trying to execute but can't because it's missing key configuration or some configuration value is itself invalid. This is the app developer's fault -- the action needs to be corrected in order to work. */ class MisconfiguredActionError extends errorClass("GGT_MISCONFIGURED_ACTION", "Invalid action configuration, request cannot be processed until this is corrected.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Thrown when a validation is trying to execute but can't because it's missing key configuration or some configuration value is itself invalid. This is the app developer's fault -- the validation needs to be corrected in order to work. */ class MisconfiguredValidationError extends errorClass("GGT_MISCONFIGURED_VALIDATION", "Invalid validation configuration, request cannot be processed until this is corrected.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Thrown when a code snippet is linked by a Gadget object (like an effect or a computed field) but the corresponding file for the linked path isn't found in the application's filesystem. */ class MisconfiguredCodeSnippetError extends errorClass("GGT_MISCONFIGURED_CODE_SNIPPET", "Code snippet referenced unknown file, request cannot be processed until this is corrected.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/**
 * Represents an error caused by the user trying to do something that can't be done right now
 * Not an exceptional circumstance from Gadget's point of view, but we still use error handling to implement user feedback in these situations for mobx-state-tree's atomic support
 */ class UserInitiatedActionSemanticError extends errorClass("GGT_USER_INITIATED_ACTION_SEMANTIC_ERROR", "User initiated action", {
    statusCode: 500,
    causedByClient: true,
    causedByUserland: false
}) {
}
/**
 * Represents an error caused by backend data not being returned from the backend. This is unexpected -- it probably means there is an issue with the network connection or a backend bug. Gadget's fault.
 */ class FailedNetworkOperationError extends errorClass("GGT_FAILED_NETWORK_OPERATION", "There was an unexpected error communicating with the Gadget backend. Please try again.", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: false,
    exposeToSandbox: true
}) {
}
/**
 * Represents the error thrown when trying to apply a JSON field's default but the stored default value isn't a valid JSON string
 */ class InvalidJSONDefaultError extends errorClass("GGT_INVALID_JSON_DEFAULT", "Invalid JSON default value", {
    causedByUserland: true
}) {
    constructor(originalMessage, details){
        super(`Invalid JSON default, cannot apply to record. Parse error: ${originalMessage}`, details);
    }
}
/**
 * Thrown when an API call arrives at an application that isn't done being created.
 */ class StillSettingUpError extends errorClass("GGT_STILL_SETTING_UP", "This Gadget application is still being set up in the background and isn't yet ready to serve requests. Please try again in a few seconds.", {
    statusCode: 503,
    causedByClient: true,
    causedByUserland: false,
    exposeToClient: true,
    exposeToSandbox: true
}) {
}
/**
 * Thrown when an API call arrives at an environment that hasn't been deployed
 */ class UndeployedEnvironmentError extends errorClass("GGT_UNDEPLOYED_ENVIRONMENT", "This Gadget application has not been deployed to Production.", {
    statusCode: 422,
    causedByClient: true,
    causedByUserland: false,
    exposeToClient: true,
    exposeToSandbox: true
}) {
}
/**
 * Represents the error thrown when the application's package.json file doesn't follow the JSON or package.json specification:
 * - https://www.json.org/json-en.html
 * - https://docs.npmjs.com/cli/v8/configuring-npm/package-json
 */ class BrokenPackageJSONError extends errorClass("GGT_BROKEN_PACKAGE_JSON", "The application's package.json file is not valid", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
    constructor(originalMessage, details){
        super(`The application's package.json file is not valid. Parse error: ${originalMessage}`, details);
    }
}
/** Thrown when an application hits its rate limit */ class TooManyRequestsError extends errorClass("GGT_TOO_MANY_REQUESTS", "The application has received too many requests and has exhausted its available resources. Try again after waiting a little while so more resources are available.", {
    statusCode: 429,
    causedByClient: true
}) {
    constructor(originalMessage, details){
        super(originalMessage, details);
    }
}
/** Thrown when an application hits its rate limit */ class InfiniteLoopError extends errorClass("GGT_INFINITE_LOOP_DETECTED", "The application has triggered an infinite loop detection, the same resource has been updated too many times in quick succession. Check to see if you are updating a model from that model's update effect.", {
    statusCode: 400,
    causedByClient: true
}) {
}
/** Thrown when an application asks for a page size bigger than the maximum allowed */ class InvalidPageSizeError extends errorClass("GGT_INVALID_PAGE_SIZE", "The application has requested a page size that is too large. Please try again with a smaller page size.", {
    statusCode: 400,
    causedByClient: true
}) {
}
/** Thrown when backwards pagination is not supported */ class InvalidBackwardsPaginationError extends errorClass("GGT_INVALID_BACKWARDS_PAGINATION", "Paginating a related connection backwards is not supported.", {
    statusCode: 400,
    causedByClient: true
}) {
}
/** Thrown when the sandbox can't run requests because the process is still starting up and isn't listening yet */ class SandboxReloadingError extends errorClass("GGT_SANDBOX_RELOADING", "Can't make requests to the application because its backend process is reloading and not ready to serve requests", {
    statusCode: 500,
    causedByUserland: true
}) {
}
/** Thrown when the sandbox can't run requests because the process failed to boot or crashed */ class AppCrashError extends errorClass("GGT_APP_CRASH", "The application has crashed and can no longer serve requests", {
    statusCode: 500,
    causedByUserland: true
}) {
}
/** Thrown when we're trying to process data from a remote system and it's missing an ID that we need to be present */ class InvalidShopifySessionTokenError extends errorClass("GGT_INVALID_SHOPIFY_SESSION_TOKEN", "Invalid Shopify Session Token provided", {
    statusCode: 401,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Thrown when we receive 401 Unauthorized from Shopify's API */ class ShopifyAuthenticationError extends errorClass("GGT_SHOPIFY_AUTHENTICATION_ERROR", "Unable to authenticate with Shopify", {
    statusCode: 401,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Thrown when we receive 403 Forbidden from Shopify's API */ class ShopifyForbiddenError extends errorClass("GGT_SHOPIFY_FORBIDDEN_ERROR", "Invalid Shopify permissions", {
    statusCode: 403,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Thrown when we're trying to process data from a remote system and it's missing an ID that we need to be present */ class MissingIdentifierInRemoteBlobError extends errorClass("GGT_MISSING_REMOTE_IDENTIFIER", "Can't process input data from a remote system because it's missing an identifier Gadget expects to exist", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: false,
    exposeToSandbox: true
}) {
}
/** Thrown when a request tries to fork an app it doesn't have permission to fork */ class UnforkableAppError extends errorClass("GGT_UNFORKABLE_APP", "Can't fork this application, please ensure it exists and has permitted forking", {
    statusCode: 401,
    causedByClient: true,
    causedByUserland: false
}) {
}
/** Throw when an unknown Webhook registration occurs */ class WebhookRegistrationError extends errorClass("GGT_WEBHOOK_REGISTRATION_FAILED", "An error occurred while registering webhook(s)", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: false,
    exposeToSandbox: true
}) {
    constructor(message, details = {}){
        super(message);
        this.causedByClient = details.causedByClient ?? false;
    }
}
/** Throw when an application is unavailable because it is suspended */ class ApplicationLockedError extends errorClass("GGT_APPLICATION_LOCKED", "This application is unavailable.", {
    statusCode: 423,
    causedByClient: false,
    causedByUserland: true,
    exposeToSandbox: true
}) {
}
/** Throw when an application is unavailable because payment is required */ class PaymentRequiredError extends errorClass("GGT_PAYMENT_REQUIRED", "Payment is required for this application.", {
    statusCode: 402,
    causedByClient: false,
    causedByUserland: true,
    exposeToSandbox: true
}) {
}
/** Throw when a developer is accessing a shopify shop which is in the 'frozen' state - meaning they have unpaid bills/dues to shopify*/ class ShopifyFrozenError extends errorClass("GGT_SHOPIFY_FROZEN", "Unable to access shop because of unpaid Shopify dues", {
    statusCode: 402,
    causedByClient: false,
    causedByUserland: true,
    exposeToSandbox: true
}) {
}
/** Throw when a client's shopify shop throw's errors akin to the tune of unavailablility*/ class ShopifyUnavailableError extends errorClass("GGT_SHOPIFY_UNAVAILABLE", "The Shopify shop is unavailable at this time, please try again later", {
    statusCode: 404,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Thrown as a catchall when we are unsure why the shopifyAPI returns an unhandled response */ class ShopifyRequestError extends errorClass("GGT_SHOPIFY_REQUEST_ERROR", "An error occurred making an API call to Shopify", {
    statusCode: 400,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Thrown when a request to shopify responds with HTTP 429 and it won't be retried */ class ShopifyRateLimitError extends errorClass("GGT_SHOPIFY_RATE_LIMIT", "You have exceeded Shopify's API rate limit. Please try again later.", {
    statusCode: 429,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Throw when an unknown Webhook registration occurs */ class AssetBuildFailedError extends errorClass("GGT_ASSET_BUILD_FAILED", "An error occurred while building production assets", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: true
}) {
}
/** Throw when an operation tries to compare vectors with different dimensions */ class DifferentVectorDimensionsError extends errorClass("GGT_DIFFERENT_VECTOR_DIMENSIONS", "This operation tried to compare vectors with different dimensions, which is an undefined operation. Please ensure all stored data and input data has the same number of dimensions.", {
    statusCode: 500,
    causedByClient: true,
    causedByUserland: true
}) {
}
/** Throw when validating a trigger in GraphQL fails */ class InvalidActionTrigger extends errorClass("GGT_INVALID_ACTION_TRIGGER", "The trigger provided is missing properties and cannot be processed.", {
    statusCode: 400,
    causedByClient: true
}) {
}
/** Throw when you need a generic client error */ class BadRequestError extends errorClass("GGT_BAD_REQUEST", "Bad request", {
    statusCode: 400,
    causedByClient: true,
    causedByUserland: true
}) {
}
class InvalidEmailError extends errorClass("GGT_INVALID_EMAIL_REQUEST", "Invalid Email input", {
    statusCode: 400,
    causedByClient: true,
    causedByUserland: true
}) {
}
/** Thrown when an error occurs with database indexing */ class PostgresIndexError extends errorClass("GGT_PSQL_INDEX_ERROR", "Bad request", {
    statusCode: 500,
    causedByClient: false,
    causedByUserland: false
}) {
}
/** Thrown when an invalid value is returned from an action's run effect */ class InvalidActionReturnType extends errorClass("GGT_ACTION_RETURN_TYPE", "Invalid value returned from action run effect", {
    statusCode: 500,
    causedByUserland: true,
    causedByClient: false
}) {
}
/** Thrown when adding adding a trigger that exposes a public API and one already exists on the action */ class InvalidPublicApiTrigger extends errorClass("GGT_INVALID_API_TRIGGER", "This action cannot have more than 1 trigger that is a public API trigger", {
    statusCode: 400,
    causedByClient: true,
    causedByUserland: true
}) {
    action;
    model;
    triggers;
    constructor(message, details){
        super(message);
        this.action = details?.action;
        this.model = details?.model;
        this.triggers = details?.triggers;
    }
}
/**
 * Thrown when a User signIn attempt fails due to an invalid email or password.
 */ class InvalidEmailPasswordError extends errorClass("GGT_INVALID_EMAIL_PASSWORD", "Invalid email or password", {
    statusCode: 401,
    causedByClient: true,
    causedByUserland: false
}) {
}
/**
 * Thrown when a reset password link is followed with an invalid or expired token.
 */ class InvalidResetPasswordTokenError extends errorClass("GGT_INVALID_RESET_PASSWORD_TOKEN", "Invalid or expired password reset token", {
    statusCode: 401,
    causedByClient: true,
    causedByUserland: false
}) {
}
/**
 * Thrown when a verify email link is followed with an invalid or expired token.
 */ class InvalidEmailVerificationToken extends errorClass("GGT_INVALID_EMAIL_VERIFICATION_TOKEN", "Invalid or expired email verification token", {
    statusCode: 401,
    causedByClient: true,
    causedByUserland: false
}) {
}
/**
 * Thrown when a User changePassword attempt fails due to an invalid currentPassword.
 */ class InvalidCurrentPasswordError extends errorClass("GGT_INVALID_CURRENT_PASSWORD", "The current password was incorrect", {
    statusCode: 401,
    causedByClient: true,
    causedByUserland: false
}) {
}
/**
 * Thrown when a User signIn attempt fails due to requiring email verification.
 */ class EmailUnverifiedError extends errorClass("GGT_EMAIL_VERIFICATION_REQUIRED", "User must verify their email before signing in", {
    statusCode: 401,
    causedByClient: true,
    causedByUserland: false
}) {
}
class InvalidPasswordResetRequest extends errorClass("GGT_INVALID_PASSWORD_RESET_REQUEST", "Invalid password reset request", {
    statusCode: 400,
    causedByClient: true,
    causedByUserland: false
}) {
}
class EmailNotFoundError extends errorClass("GGT_EMAIL_NOT_FOUND", "Email not found", {
    statusCode: 404,
    causedByClient: true,
    causedByUserland: false
}) {
}
const GadgetErrors = [
    InternalError,
    GraphQLTransactionSequenceError,
    ClientTransactionTimeoutError,
    DatabaseOperationTimeoutError,
    NotFoundError,
    PermissionDeniedError,
    UnknownFieldError,
    InvalidIDError,
    InvalidBackgroundActionIDError,
    InvalidQueryInputError,
    InvalidActionInputError,
    InvalidStoredDataError,
    InvalidAPIKeyError,
    InvalidInternalAuthTokenError,
    InvalidAuthModeError,
    ShopifyInvalidPlanNameError,
    MisconfiguredFieldError,
    NonUniqueConstraintError,
    UniqueValidationNotSupportedError,
    UnknownInputTypeError,
    InactiveSessionAccessError,
    UserNotSetOnSessionError,
    NoSessionForAuthenticationError,
    IncorrectEnvironmentTokenError,
    IncorrectAppTokenError,
    ExpiredSessionForAuthenticationError,
    AuthorizationCodeValidationError,
    AuthorizationInvalidRequest,
    UnknownPlanItemError,
    NoTransitionError,
    MissingRequiredModelError,
    MissingRequiredActionError,
    MissingRequiredFieldError,
    MissingRequiredDataError,
    MissingRequiredValidationError,
    PreconditionsFailedForActionError,
    ActionTimeoutError,
    MisconfiguredActionError,
    MisconfiguredValidationError,
    MisconfiguredCodeSnippetError,
    UserInitiatedActionSemanticError,
    FailedNetworkOperationError,
    InvalidJSONDefaultError,
    StillSettingUpError,
    BrokenPackageJSONError,
    TooManyRequestsError,
    InvalidPageSizeError,
    InvalidBackwardsPaginationError,
    SandboxReloadingError,
    AppCrashError,
    InvalidShopifySessionTokenError,
    ShopifyAuthenticationError,
    MissingIdentifierInRemoteBlobError,
    UnforkableAppError,
    WebhookRegistrationError,
    ApplicationLockedError,
    PaymentRequiredError,
    ShopifyFrozenError,
    ShopifyUnavailableError,
    ShopifyRequestError,
    AssetBuildFailedError,
    DifferentVectorDimensionsError,
    BadRequestError,
    InvalidActionTrigger,
    InvalidActionReturnType,
    InvalidEmailPasswordError,
    InvalidCurrentPasswordError,
    EmailUnverifiedError,
    InvalidResetPasswordTokenError,
    InvalidPasswordResetRequest,
    EmailNotFoundError
];
// the list of TypeScript diagnostic codes we ignore by default when reporting problems
const DefaultIgnoredJSDiagnosticCodes = [
    2307,
    2589,
    80001
];


/***/ }),

/***/ 81569:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   g: () => (/* binding */ DataType)
/* harmony export */ });
/** Enum for display-friendly data type names */ var DataType;
(function(DataType) {
    DataType["Precondition"] = "Precondition";
    DataType["Connection"] = "Connection";
    DataType["Effect"] = "Effect";
    DataType["Validation"] = "Validation";
    DataType["ValidationConfiguration"] = "ValidationConfiguration";
    DataType["Action"] = "Action";
    DataType["ActionSection"] = "Action Section";
    DataType["GlobalAction"] = "Global Action";
    DataType["State"] = "State";
    DataType["Transition"] = "Transition";
    DataType["ModelField"] = "Field";
    DataType["DataModel"] = "Model";
    DataType["SourceFile"] = "File";
})(DataType || (DataType = {}));


/***/ }),

/***/ 27771:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B$: () => (/* binding */ maybePluralize),
/* harmony export */   bs: () => (/* binding */ joinWords),
/* harmony export */   yc: () => (/* binding */ slugnderscore)
/* harmony export */ });
/* unused harmony export toSlug */
/* harmony import */ var inflected__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83677);

const slugnderscore = (str)=>(0,inflected__WEBPACK_IMPORTED_MODULE_0__/* .parameterize */ .XB)(str, {
        separator: "_"
    }).replace(/[^a-zA-Z0-9_]/g, "_");
const toSlug = (name)=>dasherize(slugnderscore(name));
const maybePluralize = (word, options)=>options.count == 1 ? word : (0,inflected__WEBPACK_IMPORTED_MODULE_0__/* .pluralize */ ._6)(word, options.locale);
/** Joins an array of words using grammatically correct punctuation and words ("and") */ const joinWords = (words)=>{
    if (words.length === 0) return "";
    const localWords = [
        ...words
    ];
    const last = localWords.pop();
    const length = localWords.length;
    return length === 0 ? last : `${localWords.join(", ")}${length > 1 ? "," : ""} and ${last}`;
};


/***/ }),

/***/ 2337:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BS: () => (/* binding */ StringFieldTypes),
/* harmony export */   HL: () => (/* binding */ TitleFieldTypes),
/* harmony export */   Lg: () => (/* binding */ FieldTypeMSTEnum),
/* harmony export */   S6: () => (/* binding */ RelationshipFieldTypes),
/* harmony export */   Wj: () => (/* binding */ ParentRelationshipFieldTypes),
/* harmony export */   Yg: () => (/* binding */ NumericFieldTypes),
/* harmony export */   fS: () => (/* binding */ FieldType),
/* harmony export */   gt: () => (/* binding */ OwnedFieldTypes),
/* harmony export */   rQ: () => (/* binding */ CaseSensitiveFieldTypes)
/* harmony export */ });
/* unused harmony exports PluralRelationshipFieldTypes, SortableTypes */
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39711);
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__);

var FieldType;
(function(FieldType) {
    /**
   * Any value at all.
   * Prefer FieldType.JSON where possible, it's more descriptive.
   * @deprecated
   */ FieldType["Any"] = "Any";
    FieldType["Array"] = "Array";
    FieldType["BelongsTo"] = "BelongsTo";
    FieldType["Boolean"] = "Boolean";
    FieldType["Code"] = "Code";
    FieldType["Color"] = "Color";
    FieldType["Computed"] = "Computed";
    FieldType["DateTime"] = "DateTime";
    FieldType["Email"] = "Email";
    FieldType["EncryptedString"] = "EncryptedString";
    FieldType["Enum"] = "Enum";
    FieldType["File"] = "File";
    FieldType["HasMany"] = "HasMany";
    FieldType["HasManyThrough"] = "HasManyThrough";
    FieldType["HasOne"] = "HasOne";
    FieldType["ID"] = "ID";
    FieldType["JSON"] = "JSON";
    FieldType["Money"] = "Money";
    FieldType["Null"] = "Null";
    FieldType["Number"] = "Number";
    FieldType["Object"] = "Object";
    FieldType["Password"] = "Password";
    FieldType["RecordState"] = "RecordState";
    FieldType["RichText"] = "RichText";
    FieldType["RoleAssignments"] = "RoleAssignments";
    FieldType["String"] = "String";
    FieldType["URL"] = "URL";
    FieldType["Vector"] = "Vector";
})(FieldType || (FieldType = {}));
const FieldTypeMSTEnum = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.enumeration(Object.values(FieldType));
// The data that could be used as the title of a record
const TitleFieldTypes = [
    "String",
    "URL",
    "Email",
    "Color",
    "Any"
];
// Data for which there's a natural, meaningful-to-humans string representation available
const StringFieldTypes = [
    "String",
    "RichText",
    "URL",
    "Email",
    "Color"
];
// Data for which there's a numeric, meaningful-to-humans readable numeric representation available
const NumericFieldTypes = [
    "Number",
    "Money"
];
// Data powered by a relationship to a record or records of another model
const RelationshipFieldTypes = [
    "HasManyThrough",
    "HasMany",
    "HasOne",
    "BelongsTo"
];
// Data powered by a relationship to many records of another model
const PluralRelationshipFieldTypes = (/* unused pure expression or super */ null && ([
    "HasManyThrough",
    "HasMany"
]));
const ParentRelationshipFieldTypes = [
    "HasManyThrough",
    "HasMany",
    "HasOne"
];
// Types that can be sorted.
const SortableTypes = (/* unused pure expression or super */ null && ([
    "ID",
    "String",
    "URL",
    "Number",
    "Money",
    "Boolean",
    "DateTime",
    "Color",
    "Vector"
]));
// Data types for which the record actually contains and actually owns the data.
// Excludes fields like the Gadget system fields that the developer can't really muck with, and fields like HasMany or Computed, where the value is derived from other data as opposed to a plain old scalar on the record.
const OwnedFieldTypes = [
    "Number",
    "String",
    "Enum",
    "RichText",
    "DateTime",
    "Email",
    "URL",
    "Money",
    "File",
    "Color",
    "Boolean",
    "JSON",
    "Any",
    "BelongsTo",
    "EncryptedString",
    "Vector"
];
// Types for data that can be meaningfully differentiated by toggling case sensitivity (ie. when verifying uniqueness)
const CaseSensitiveFieldTypes = [
    "String",
    "RichText",
    "Email",
    "URL"
];


/***/ }),

/***/ 94910:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A5: () => (/* binding */ validationModelKey),
/* harmony export */   Ab: () => (/* binding */ defaultNowDateType),
/* harmony export */   DS: () => (/* binding */ moveMSTArrayElement),
/* harmony export */   E6: () => (/* binding */ gadgetModelType),
/* harmony export */   GA: () => (/* binding */ mapToObject),
/* harmony export */   HI: () => (/* binding */ generateKey),
/* harmony export */   I3: () => (/* binding */ getDataTypeDisplayName),
/* harmony export */   Iv: () => (/* binding */ convertCurrencyToBaseUnits),
/* harmony export */   Jo: () => (/* binding */ isLiveRoot),
/* harmony export */   N3: () => (/* binding */ errorMessage),
/* harmony export */   N8: () => (/* binding */ getMountedHTTPPathFromRouteFilePath),
/* harmony export */   ON: () => (/* binding */ prettyJSON),
/* harmony export */   Qo: () => (/* binding */ getClientPackageName),
/* harmony export */   RJ: () => (/* binding */ GadgetModelClass),
/* harmony export */   TO: () => (/* binding */ stringBucketHash),
/* harmony export */   V9: () => (/* binding */ unthunk),
/* harmony export */   VV: () => (/* binding */ fieldSortIterators),
/* harmony export */   Ww: () => (/* binding */ firstAncestorImplementing),
/* harmony export */   Xb: () => (/* binding */ actionSortIterators),
/* harmony export */   _v: () => (/* binding */ sleep),
/* harmony export */   bf: () => (/* binding */ getAllParentsThroughGeneratingRoot),
/* harmony export */   cK: () => (/* binding */ validateColorString),
/* harmony export */   cR: () => (/* binding */ countDecimals),
/* harmony export */   eV: () => (/* binding */ numberOfDecimalsForCurrency),
/* harmony export */   fq: () => (/* binding */ GeneratingParentVolatileClass),
/* harmony export */   gX: () => (/* binding */ serializeObjectToHTTPQuery),
/* harmony export */   hg: () => (/* binding */ gadgetDomainModelType),
/* harmony export */   hu: () => (/* binding */ assert),
/* harmony export */   iD: () => (/* binding */ syncLogqlQuery),
/* harmony export */   iK: () => (/* binding */ defaultLogqlQuery),
/* harmony export */   iL: () => (/* binding */ stableSnapshotJSON),
/* harmony export */   jB: () => (/* binding */ debugActions),
/* harmony export */   jI: () => (/* binding */ getGadgetEnv),
/* harmony export */   jl: () => (/* binding */ getLogger),
/* harmony export */   k1: () => (/* binding */ contentHash),
/* harmony export */   le: () => (/* binding */ gadgetModelKey),
/* harmony export */   lt: () => (/* binding */ convertCurrencyToSubUnits),
/* harmony export */   mE: () => (/* binding */ validateNumber),
/* harmony export */   n: () => (/* binding */ maybeGetParentOfType),
/* harmony export */   nR: () => (/* binding */ deserializeObjectFromHTTPQuery),
/* harmony export */   qD: () => (/* binding */ GadgetDomainModelClass),
/* harmony export */   r5: () => (/* binding */ fieldTypeName),
/* harmony export */   rd: () => (/* binding */ nodeTypeType),
/* harmony export */   sy: () => (/* binding */ getGeneratingRoot)
/* harmony export */ });
/* unused harmony exports weakMapMemoize, never, keyType, niceTypeName, isNodeOfType, getAncestors, isAncestor, stripModelKeyPrefix, nodeContainerModel, getClientPackageScope, cyrb53, defineGeneratingParentVolatile, runOnceInObserver, HARDCODED_FIELD_ORDER, HARDCODED_ACTION_ORDER, HARDCODED_USER_ACTION_ORDER, HARDCODED_USER_ACTION_REVERSED_ORDER, HARDCODED_ACTION_REVERSED_ORDER, MAX_FUTURE_TIMESTAMP, createDateSortIterator, actionIterator, fieldIterator, validationSortIterators */
/* harmony import */ var _swc_helpers_ts_decorate__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(43112);
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39711);
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var inflected__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83677);
/* harmony import */ var lodash_clamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95434);
/* harmony import */ var lodash_clamp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_clamp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89256);
/* harmony import */ var lodash_isBoolean__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isBoolean__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79409);
/* harmony import */ var lodash_isError__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isError__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_isFunction__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45563);
/* harmony import */ var lodash_isFunction__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isFunction__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14698);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_isNull__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7534);
/* harmony import */ var lodash_isNull__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_isNull__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3224);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash_isUndefined__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86474);
/* harmony import */ var lodash_isUndefined__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_isUndefined__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77875);
/* harmony import */ var lodash_last__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_last__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67997);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_memoize__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65668);
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26239);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46163);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var safe_stable_stringify__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94355);
/* harmony import */ var _DataType__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(81569);
/* harmony import */ var _stringUtils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(27771);
/* harmony import */ var _type_system_FieldType__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2337);
/* eslint-disable @typescript-eslint/ban-types */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports





















function assert(value, message) {
    if (!value) {
        throw new Error("assertion error" + (message ? `: ${message}` : ""));
    }
    return value;
}
const unthunk = (value, ...args)=>{
    if (lodash_isFunction__WEBPACK_IMPORTED_MODULE_5___default()(value)) {
        return value(...args);
    } else {
        return value;
    }
};
const weakMapMemoize = (func, resolver)=>{
    const memoized = memoize(func, resolver);
    memoized.cache = new WeakMap();
    return memoized;
};
const never = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.frozen();
const generateKey = ()=>(0,nanoid__WEBPACK_IMPORTED_MODULE_18__/* .nanoid */ .x0)(12);
const keyType = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.identifier, generateKey);
const niceTypeName = (type)=>type.name;
/** Action definition function for mobx-state-trees that adds handy actions to them in development for debugging */ // eslint-disable-next-line @typescript-eslint/ban-types
const debugActions = (self)=>{
    return {
        debugAssign (values) {
            for (const [key, value] of Object.entries(values)){
                self[key] = value;
            }
        }
    };
};
/** Boolean checker and TypeScript type guard that checks if a given doodad is an instance of a mobx-state-tree type. It'd be nice to use mobx-state-tree's built in Type.is() for this, but .is() returns true for snapshots as well as instances, this checks explicitly for instances. */ function isNodeOfType(node, type) {
    return isStateTreeNode(node) && type.is(node);
}
const getAncestors = (node)=>{
    const result = [];
    let cursor = node;
    while(!isRoot(cursor)){
        cursor = getParent(cursor);
        result.push(cursor);
    }
    return result;
};
const isAncestor = (node, maybeAncestor)=>{
    let cursor = node;
    while(!isRoot(cursor)){
        cursor = getParent(cursor);
        if (cursor == maybeAncestor) {
            return true;
        }
    }
    return false;
};
const firstAncestorImplementing = (node, func)=>{
    let cursor = node;
    while(!(0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.isRoot)(cursor)){
        cursor = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getParent)(cursor);
        if (func in cursor) {
            return cursor;
        }
    }
    return null;
};
const maybeGetParentOfType = (node, type)=>{
    try {
        return (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getParentOfType)(node, type);
    } catch (e) {
        return null;
    }
};
/**
 * @deprecated Please use OrderedMaps to store ordered lists of things
 */ const moveMSTArrayElement = (array, from, delta)=>{
    const newItems = array.slice();
    const to = lodash_clamp__WEBPACK_IMPORTED_MODULE_2___default()(from + delta, 0, array.length - 1);
    newItems.splice(to, 0, newItems.splice(from, 1)[0]);
    array.replace(newItems);
};
/** A Date type that sets itself to now the first time an instance is created */ const defaultNowDateType = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.Date, ()=>luxon__WEBPACK_IMPORTED_MODULE_12__/* .DateTime */ .ou.utc().toJSDate());
/**
 *  Returns a MST type that sticks a string literal in the actual nodes that TypeScript understands, so a Page without any other properties might have a JSON representation of `{"tag": "Page"}`. Useful for understanding what the heck is where and what type it is, as well as for typescript's discriminated unions and switch statements on unions of types that are typesafe automagically (switch node.tag ...)
 */ const nodeTypeType = (type)=>_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.literal(type), type);
const validationModelKey = (fieldKey, validationSpecId, order)=>{
    return `Validation-${fieldKey}-${validationSpecId}-${order}`;
};
/**
 * Return a unique key for a Gadget MST model with the given name.
 */ const gadgetModelKey = (name)=>{
    return name + "-" + generateKey();
};
/**
 * Return the key of a type without its type prefix.
 */ const stripModelKeyPrefix = (model)=>{
    return model.key.replace(`${model.type}-`, "");
};
/**
 * Gadget specific. Defines a mobx-state-tree model type with a name, a type property, and a key property. Similar to `gadgetDomainModelType`, but should be preferred for transient or framework-y types. Anything that goes in the database should use `gadgetDomainModelType`.
 * Equivalent to calling:
 *
 * ```typescript
 * types.model(name, { type: nodeTypeType(name), key: keyType})
 * ```
 *
 * The name is useful for debugging, the `type` property is useful for TypeScript discriminated unions typechecking and for mobx-state-tree's runtime union resolution, and the key is useful for always having an identifier for a tree node to use in references.
 * @deprecated use Class Models instead
 * @see GadgetModelClass
 */ const gadgetModelType = (name, options)=>_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.model(name, {
        type: nodeTypeType(name),
        key: _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.identifier, ()=>gadgetModelKey(name)),
        ...options
    }).actions(debugActions);
/**
 * Defines a mobx-quick-tree base model class model type with a name, a type property, and a key property. Similar to `GadgetDomainModelClass`,  but should be preferred for transient or framework-y types. Anything that goes in the database should use `gadgetDomainModelType`.
 *
 * The name is useful for debugging, the `type` property is useful for TypeScript discriminated unions typechecking and for mobx-state-tree's runtime union resolution, and the key is useful for always having an identifier for a tree node to use in references.
 */ const GadgetModelClass = (name, options)=>(0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.ClassModel)({
        type: nodeTypeType(name),
        key: _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.identifier, ()=>gadgetModelKey(name)),
        ...options
    });
/**
 * Gadget specific. Defines a mobx-state-tree model type with a name, a type property, a key property, and bookkeeping properties for tracking when the object was created. Similar to `gadgetModelType`, but should be preferred for any non-transient or high value objects that get persisted.
 *
 * The name is useful for debugging, the `type` property is useful for TypeScript discriminated unions typechecking and for mobx-state-tree's runtime union resolution, and the key is useful for always having an identifier for a tree node to use in references.
 *
 * @deprecated use Class Models instead
 * @see GadgetDomainModelClass
 */ const gadgetDomainModelType = (name, options)=>_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.model(name, {
        type: nodeTypeType(name),
        key: _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.identifier, ()=>gadgetModelKey(name)),
        createdDate: defaultNowDateType,
        ...options
    }).actions(debugActions);
/**
 * Defines a mobx-quick-tree base model class model type with a name, a type property, a key property, and bookkeeping properties for tracking when the object was created. Similar to `gadgetModelClass`, but should be preferred for any non-transient or high value objects that get persisted.
 *
 * The name is useful for debugging, the `type` property is useful for TypeScript discriminated unions typechecking and for mobx-state-tree's runtime union resolution, and the key is useful for always having an identifier for a tree node to use in references.
 */ const GadgetDomainModelClass = (name, options)=>(0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.ClassModel)({
        type: nodeTypeType(name),
        key: _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.identifier, ()=>gadgetModelKey(name)),
        createdDate: defaultNowDateType,
        ...options
    });
/**
 * Returns an MST model type that has a `children` array of the passed type and actions for mutating that.
 * Useful for creating View nodes that hold a bunch of children and need to let the Selection mutate them.
 */ const nodeContainerModel = (name, childType)=>{
    return types.model(name, {
        type: nodeTypeType(name),
        key: types.optional(types.identifier, ()=>gadgetModelKey(name)),
        createdDate: defaultNowDateType,
        children: types.array(childType)
    }).actions(debugActions).actions((self)=>({
            addChild (node) {
                self.children.push(node);
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return last(self.children);
            },
            removeChild (node) {
                self.children.remove(node);
            },
            moveChild (node, delta) {
                moveMSTArrayElement(self.children, self.children.indexOf(node), delta);
            }
        }));
};
const prettyJSON = (value)=>JSON.stringify(value, null, 2);
const getClientPackageScope = (env = "development")=>{
    return env == "production" ? "@gadget-client" : `@gadget-client-${env}`;
};
/**
 * Get the name of the npm package for an application's generated client, like `@gadget-client/my-cool-blog`
 * We use a per-app package name for each client so that external projects can install clients from more than one gadget app
 **/ const getClientPackageName = (platformEnv = "development", slug)=>{
    if (false) {}
    return `${getClientPackageScope(platformEnv)}/${slug}`;
};
const getGadgetEnv = (node)=>{
    const env = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getEnv)(node);
    if (!env.extensionRegistry) {
        throw new Error(`Can't get gadget env for tree node ${String(node)}, current env at the root doesn't have expected Gadget keys`);
    }
    return env;
};
const getLogger = (node)=>{
    const env = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getEnv)(node);
    if (!env.console) {
        throw new Error(`Can't get gadget logger for tree node ${String(node)}, current env at the root doesn't have expected console key`);
    }
    return env.console;
};
/**
 * General purpose fast hashing function that works in the browser and in node.
 * Credit https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
 **/ const cyrb53 = (str, seed = 0)=>{
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for(let i = 0, ch; i < str.length; i++){
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
    h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};
/**
 * Utility to produce a content hash from a list of a model's values which define it's content
 */ const contentHash = Object.assign((values)=>{
    const stringified = values.map((value)=>{
        if (lodash_isNull__WEBPACK_IMPORTED_MODULE_7___default()(value)) return "<<null>>";
        if (lodash_isUndefined__WEBPACK_IMPORTED_MODULE_9___default()(value)) return "<<undefined>>";
        if (lodash_isBoolean__WEBPACK_IMPORTED_MODULE_3___default()(value)) return `<<${String(value)}>>`;
        if (lodash_isNumber__WEBPACK_IMPORTED_MODULE_8___default()(value)) return `##${String(value)}`;
        return value;
    });
    const hash = cyrb53(stringified.join("///"));
    // when we want to diagnose why content hashes don't match, this lets us compare the whole tree of values that went into a hash. it's just slow so we only activate this during the tests
    if (contentHash.includeDebugInfo) {
        contentHash.debugInfos[hash] = values.map((value)=>{
            if (lodash_isNumber__WEBPACK_IMPORTED_MODULE_8___default()(value) && contentHash.debugInfos[value]) {
                return contentHash.debugInfos[value];
            } else {
                return value;
            }
        });
    }
    return hash;
}, {
    debugInfos: {},
    includeDebugInfo: false
});
const validateNumber = (numberAsString, maximumDecimals)=>{
    if (isFinite(Number(numberAsString))) {
        return !lodash_isNil__WEBPACK_IMPORTED_MODULE_6___default()(maximumDecimals) ? countDecimals(Number(numberAsString)) <= maximumDecimals : true;
    }
    return false;
};
const countDecimals = (value)=>{
    if (!isFinite(value)) {
        return 0;
    }
    return value.toString().split(".")[1]?.length || 0;
};
const validateColorString = (colorString)=>/^#([0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(colorString);
/**
 * These should be updated to refer to a library that can convert based on the currency when we support more than CAD and USD.
 */ const convertCurrencyToSubUnits = (value)=>{
    if (!isFinite(value)) {
        return 0;
    }
    return Math.round(value * 100); //round to ensure the result is an integer and protect against floating point math errors
};
const convertCurrencyToBaseUnits = (value)=>{
    if (!isFinite(value)) {
        return 0;
    }
    return value / 100.0;
};
const numberOfDecimalsForCurrency = ()=>{
    return 2;
};
/**
 *  Get a JSON stringified snapshot of a model with stable (sorted) key order so the snapshot text is identical regardless of key insertion order
 */ const stableSnapshotJSON = (node)=>(0,safe_stable_stringify__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)((0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getSnapshot)(node));
const mapToObject = (map)=>Object.fromEntries(map.entries());
/**
 * Figure out if a given root MST node is a `LiveRoot`. We have a couple different live roots both client side, server side, and in production vs in the tests, so we use this utility to identify them instead of doing the same type checks everywhere.
 */ const isLiveRoot = (node)=>{
    return node.type == "ClientEnvironmentRoot" || node.type == "LiveRoot";
};
/**
 * Get a string representing an error that is an `Error` object or anything else that might be `throw`n
 */ const errorMessage = (error)=>{
    if (typeof error == "string") {
        return error;
    } else if (lodash_isError__WEBPACK_IMPORTED_MODULE_4___default()(error)) {
        return error.message;
    } else {
        return String(error);
    }
};
/**
 * Some of our derived field nodes like `ObjectField`s are often their own MST root. This is because we generate them dynamically and treat them as values that go away most of the time -- they're derived data, ephemeral, and not stuck in the tree as persisted nodes.
 *
 * Because of this, they are disconnected from the greater context that might have generated them. `getRoot(someObjectField)` often returns the object field itself, or a quite close parent of it, and it doesn't get us the `WorkspaceRoot` or `FullServerEnvironmentRoot` or whatever of the whole application which generated it. So, we track the root that really did generate the `ObjectField` in a volatile `generatingParent` property so that our traversal functions can get back to the real root when they need to.
 * @deprecated use model classes
 * @see GeneratingParentVolatileClass
 */ const defineGeneratingParentVolatile = ()=>{
    let generatingParent = null;
    return {
        views: {
            get generatingParent () {
                return generatingParent;
            }
        },
        actions: {
            setGeneratingParent (value) {
                generatingParent = value;
            }
        }
    };
};
/**
 * Some of our derived field nodes like `ObjectField`s are often their own MST root. This is because we generate them dynamically and treat them as values that go away most of the time -- they're derived data, ephemeral, and not stuck in the tree as persisted nodes.
 *
 * Because of this, they are disconnected from the greater context that might have generated them. `getRoot(someObjectField)` often returns the object field itself, or a quite close parent of it, and it doesn't get us the `WorkspaceRoot` or `FullServerEnvironmentRoot` or whatever of the whole application which generated it. So, we track the root that really did generate the `ObjectField` in a volatile `generatingParent` property so that our traversal functions can get back to the real root when they need to.
 */ const GeneratingParentVolatileClass = (Klass)=>{
    class GeneratingParentVolatile extends Klass {
        generatingParent;
        setGeneratingParent(value) {
            this.generatingParent = value;
        }
    }
    (0,_swc_helpers_ts_decorate__WEBPACK_IMPORTED_MODULE_19__/* .__decorate */ .gn)([
        (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.volatile)((_instance)=>null)
    ], GeneratingParentVolatile.prototype, "generatingParent", void 0);
    (0,_swc_helpers_ts_decorate__WEBPACK_IMPORTED_MODULE_19__/* .__decorate */ .gn)([
        _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.volatileAction
    ], GeneratingParentVolatile.prototype, "setGeneratingParent", null);
    return GeneratingParentVolatile;
};
/**
 * Returns all the parent nodes for any given node, similar to chained `getParent` calls from the MST API. But, we jump up through any ephemeral roots like `ObjectField` or `FloatingValueField` back to a really useful root like `LiveRoot` or `FullWorkspaceRoot` and keep returning parents.
 *
 * @see defineGeneratingParentVolatile
 */ const getAllParentsThroughGeneratingRoot = (node)=>{
    const parents = [];
    let cursor = node;
    while(cursor){
        if ((0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.isRoot)(cursor)) {
            const newRoot = getGeneratingRoot(cursor);
            if (newRoot != cursor) {
                cursor = newRoot;
            } else {
                break;
            }
        } else {
            cursor = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getParent)(cursor);
        }
        parents.push(cursor);
    }
    return parents;
};
/**
 * Returns the root MST node for any given node, similar to `getRoot` from the MST API. But, we jump up through any ephemeral roots like `ObjectField` or `FloatingValueField` back to a really useful root like `LiveRoot` or `FullWorkspaceRoot`.
 *
 * @see defineGeneratingParentVolatile
 */ const getGeneratingRoot = (node)=>{
    const root = (0,_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.getRoot)(node);
    // traverse to the root-most root that might have generated this root
    if ("generatingParent" in root && root.generatingParent) {
        return getGeneratingRoot(root.generatingParent);
    }
    return root;
};
/**
 * Returns a promise that when awaited on will sleep for the desired amount of time.
 * @param ms Time in milliseconds to sleep for
 * @returns A promise that will sleep for `ms` seconds.
 */ const sleep = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
/**
 * Run the given function in a mobx observer for the side effect of mobx computeds being cached.
 */ const runOnceInObserver = (func)=>{
    let result = null;
    let error = null;
    const dispose = autorun(()=>{
        try {
            result = func();
        } catch (innerError) {
            error = innerError;
        }
    });
    dispose();
    if (error) throw error;
    return result;
};
function fieldTypeName(fieldType) {
    switch(fieldType){
        case _type_system_FieldType__WEBPACK_IMPORTED_MODULE_17__/* .FieldType */ .fS.HasManyThrough:
            return "has many through";
        case _type_system_FieldType__WEBPACK_IMPORTED_MODULE_17__/* .FieldType */ .fS.RoleAssignments:
            return "role list";
        case _type_system_FieldType__WEBPACK_IMPORTED_MODULE_17__/* .FieldType */ .fS.DateTime:
            return "date / time";
        default:
            return (0,inflected__WEBPACK_IMPORTED_MODULE_1__/* .underscore */ .It)(fieldType).replace("_", " ");
    }
}
const HARDCODED_FIELD_ORDER = {
    id: 0,
    createdAt: 1,
    updatedAt: 2,
    state: 3
};
const HARDCODED_ACTION_ORDER = {
    create: 0,
    update: 1,
    delete: 2
};
const HARDCODED_USER_ACTION_ORDER = {
    signUp: 0,
    signIn: 1,
    signOut: 2,
    update: 3,
    delete: 4,
    sendVerifyEmail: 5,
    verifyEmail: 6,
    sendResetPassword: 7,
    resetPassword: 8,
    changePassword: 9
};
const HARDCODED_USER_ACTION_REVERSED_ORDER = {
    signUp: 9,
    signIn: 8,
    signOut: 7,
    update: 6,
    delete: 5,
    sendVerifyEmail: 4,
    verifyEmail: 3,
    sendResetPassword: 2,
    resetPassword: 1,
    changePassword: 0
};
const HARDCODED_ACTION_REVERSED_ORDER = {
    create: 2,
    update: 1,
    delete: 0
};
const MIN_PAST_TIMESTAMP = 31535999000;
const MAX_FUTURE_TIMESTAMP = 90000000000000;
function createDateSortIterator(record) {
    // If date is missing or close to epoch zero, use a date far into the future as a fallback
    const minDate = new Date(MIN_PAST_TIMESTAMP);
    const maxDate = new Date(MAX_FUTURE_TIMESTAMP);
    const safeDate = record.createdDate === 0 || record.createdDate <= minDate ? maxDate : record.createdDate;
    // If the date is a timestamp, use that; otherwise, use our safe date
    const isTimestamp = typeof record.createdDate === "number";
    const date = isTimestamp ? record.createdDate : safeDate.valueOf();
    return date;
}
/**
 * Lodash-centric sort function, to sort by a `createdDate` date, except in the case of the
 * 4 system values (ID, Created At, Updated At, and State), which are hardcoded to that order.
 */ function actionIterator(record, actionOrderList) {
    const id = record.apiIdentifier;
    if (actionOrderList[id] !== undefined) {
        return actionOrderList[id];
    }
    return createDateSortIterator(record);
}
function fieldIterator(record) {
    const id = record.apiIdentifier;
    if (HARDCODED_FIELD_ORDER[id] !== undefined) {
        return HARDCODED_FIELD_ORDER[id];
    }
    return createDateSortIterator(record);
}
const actionSortIterators = (action, isUserModel, opts)=>{
    let actionsOrders;
    if (isUserModel) {
        actionsOrders = opts?.descending ? HARDCODED_USER_ACTION_REVERSED_ORDER : HARDCODED_USER_ACTION_ORDER;
    } else {
        actionsOrders = opts?.descending ? HARDCODED_ACTION_REVERSED_ORDER : HARDCODED_ACTION_ORDER;
    }
    return actionIterator(action, actionsOrders);
};
/** Lodash-centric sort iterators to sort by `createdDate` and `key`, respectively */ const fieldSortIterators = [
    fieldIterator,
    "key"
];
const validationSortIterators = [
    createDateSortIterator,
    "key"
];
/** Get data type display name */ function getDataTypeDisplayName(type) {
    return String(_DataType__WEBPACK_IMPORTED_MODULE_15__/* .DataType */ .g[type] ?? type);
}
function getMountedHTTPPathFromRouteFilePath(filePath) {
    const match = filePath.match(/^\/?routes\/((\/|[^[:*]*)\/)?GET(-?([^:[*]*)(\..+)?)?\.(js|ts)$/);
    if (match) {
        const separator = match[4]?.startsWith(".") ? "" : "/";
        return "/" + [
            match[2],
            match[4]
        ].filter((m)=>m).map((m)=>m.replace(/^\/+|\/+$/g, "")).join(separator);
    } else {
        return null;
    }
}
const stringBucketHash = (str, buckets)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0; // Convert to 32-bit integer
    }
    return (hash % buckets + buckets) % buckets; // Ensure the result is within the range [0, 19]
};
const defaultLogqlQuery = (environmentId)=>{
    return environmentId ? `{environment_id="${environmentId}"} | json | level=~"info|warn|error"` : `{environment_id=~".+"} | json | level=~"info|warn|error"`;
};
const serializeObjectToHTTPQuery = (obj)=>{
    const data = qs__WEBPACK_IMPORTED_MODULE_13___default().stringify(obj);
    return data ? `?${data}` : "";
};
const deserializeObjectFromHTTPQuery = (query)=>{
    if (!query) return undefined;
    const params = query.substr(1);
    return qs__WEBPACK_IMPORTED_MODULE_13___default().parse(params);
};
const syncLogqlQuery = (syncId, startAt, environment)=>{
    return serializeObjectToHTTPQuery({
        timeRange: `${new Date(startAt).toISOString()} to now`,
        logql: `${defaultLogqlQuery()}${syncId ? ` | json | connectionSyncId = "${syncId}"` : ""}`,
        environment
    });
};


/***/ }),

/***/ 50189:
/***/ (() => {

/* (ignored) */

/***/ })

}]);